/**
 * Operator Configuration — MangoTV
 * Pattern: mirrors glotv operators.js
 *
 * MangoTV uses the 9mobile operator on the TVAnywhere backend.
 * Operator ID: 10, Operator UID: 9mobile
 * API URL: https://ott.tvanywhereafrica.com:28182
 */

const OPERATORS = {
  "9mobile": {
    operator_id: "10",
    operator_uid: "9mobile",
    country: "Nigeria (ng)",
    api_url: "https://ott.tvanywhereafrica.com:28182",
  },
};

// Default operator for MangoTV
export const DEFAULT_OPERATOR = OPERATORS["9mobile"];

export default OPERATORS;
